import React from "react";

export default function PlayVideo() {
  return (


      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
              fill="#9B27AF"/>
          <path
              d="M6.27121 5.05542C6.43774 4.96972 6.63821 4.98427 6.79062 5.09313L10.2906 7.59313C10.422 7.68699 10.5 7.83853 10.5 8C10.5 8.16148 10.422 8.31301 10.2906 8.40687L6.79062 10.9069C6.63821 11.0157 6.43774 11.0303 6.27121 10.9446C6.10467 10.8589 6 10.6873 6 10.5V5.5C6 5.31271 6.10467 5.14112 6.27121 5.05542Z"
              fill="#9B27AF"/>
      </svg>

  );
}
